import { render, staticRenderFns } from "./PmwPagination.vue?vue&type=template&id=ac84ba8a&scoped=true&"
import script from "./PmwPagination.vue?vue&type=script&lang=js&"
export * from "./PmwPagination.vue?vue&type=script&lang=js&"
import style0 from "./PmwPagination.vue?vue&type=style&index=0&id=ac84ba8a&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ac84ba8a",
  null
  
)

export default component.exports